import styles from "./styles.module.scss";

export const HeroTitle = ({children}) => {
  return <h1 className={styles.title}>{children}</h1>;
};
